export const colors = {
    type: {
        normal: '#A8A77A',
        fire: '#EE8130',
        water: '#6390F0',
        electric: '#F7D02C',
        grass: '#7AC74C',
        ice: '#96D9D6',
        fighting: '#C22E28',
        poison: '#A33EA1',
        ground: '#E2BF65',
        flying: '#A98FF3',
        psychic: '#F95587',
        bug: '#A6B91A',
        rock: '#B6A136',
        ghost: '#735797',
        dragon: '#6F35FC',
        dark: '#705746',
        steel: '#B7B7CE',
        fairy: '#D685AD',
    },

    pokemons: {
        black: '#585858',
        red: '#ff8041',
        blue: '#3088f0',
        white: '#f0f0f0',
        gray: '#a0a0a0',
        brown: '#b07030',
        green: '#40b868',
        purple: '#a868c0',
        pink: '#f890c8',
        yellow: '#f0d048'
    }
} as any